// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

// This is needed for the animation to work properly in most browsers.
// It has to be an upper bound, but not too high or the animation will lag.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ChecklistDescriptionWrapper = styled.div({
	padding: `0 ${token('space.200', '16px')} ${token(
		'space.200',
		'16px',
	)} ${token('space.200', '16px')}`,
});
